import { LoadingSpinner } from '@/components/UI/Common/Admin/LoadingSpinner';
import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';
import Table from '@/components/UI/Table/Table';
import { useResourceList } from '@/hooks/useResourceList';
import { IUserGroup } from '@/types/groups';
import { TableColumn } from '@/types/table';
import { useMemo } from 'react';
import { Filters } from '../components/Filters';
import { Pagination } from '@/components/UI/Pagination/Pagination';

export const UserGroupsPage = () => {
  const {
    data: groups,
    isLoading,
    reset,
    handleFilterChange,
    handleSortChange,
    handlePageChange,
    handleLimitChange,
    filter,
    page,
    sortOrder,
    totalPages,
    totalItems,
    limit,
    sortBy,
  } = useResourceList('user-groups');

  const columns: TableColumn<IUserGroup>[] = useMemo(
    () => [
      {
        key: 'id',
        title: 'ID',
        sortable: true,
        sortBy: sortBy,
        sortOrder: sortOrder,
        onColumnHeaderClick: handleSortChange,
      },
      {
        key: 'name',
        title: 'Название',
        sortable: true,
        sortBy: sortBy,
        sortOrder: sortOrder,
        onColumnHeaderClick: handleSortChange,
      },
      {
        key: 'createdAt',
        title: 'Создана',
        sortable: true,
        sortBy: sortBy,
        sortOrder: sortOrder,
        onColumnHeaderClick: handleSortChange,
        render: (val: unknown) =>
          new Date(val as string).toLocaleString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }),
      },
      {
        key: 'updatedAt',
        title: 'Обновлена',
        sortable: true,
        sortBy: sortBy,
        sortOrder: sortOrder,
        onColumnHeaderClick: handleSortChange,
        render: (val: unknown) =>
          new Date(val as string).toLocaleString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }),
      },
    ],
    [sortBy, sortOrder],
  );

  if (isLoading || !groups) {
    return <LoadingSpinner className="h-full" text="Загрузка..." />;
  }

  return (
    <PageLayout title="Группы пользователей">
      <Filters value={filter} onChange={handleFilterChange} onReset={reset} />

      <div className="overflow-x-auto">
        <Table data={groups.data} columns={columns} />
      </div>

      <Pagination
        className="mt-10"
        onItemsPerPageChange={handleLimitChange}
        currentPage={page}
        totalItems={totalItems}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        itemsPerPage={limit}
      />
    </PageLayout>
  );
};
